export const te = {
    "TRIGGER_LISTEN": "ప్రేరణలను వినుతూ",
    "ASSIST_EMPTY_MSG": "ఏజెంట్ AI మీ సంభాషణను సక్రియంగా వినుతూ ఉంది మరియు ప్రేరణగా ఉన్నప్పుడు స్వయంచాలకంగా సహాయం చేయడానికి సిద్ధంగా ఉంది.",
    "MYBOT_TRIGGET_LISTEN": "ప్రస్తుతం ఏ సక్రియ మై బాట్ కార్యాలు లేవు",
    "MYBOT_EMTPY_MSG": "మై బాట్ లో ఒక టాస్క్ ప్రారంభించడానికి, శోధన ట్యాబ్ కు వెళ్ళండి మరియు మీ కోరిక టాస్క్ కోసం \"\"ఏజెంట్ ఇన్పుట్స్ తో రన్ విత్\"\" ఎంపికను ఎంచుకోండి.",
    "PROACTIVE_MODE": "ప్రోయాక్టివ్ మోడ్",
    "SETTINGS": "సెట్టింగ్లు",
    "HELP_AND_SUPPORT": "సహాయం మరియు మద్దతు",
    "HELP": "సహాయం",
    "LANGUAGE": "భాషా",
    "THEME": "థీమ్",
    "AUTOMATIC": "స్వయంచాలకం",
    "DARK": "గాఢం",
    "LIGHT": "ప్రకాశం",
    "THEME_DESC": "ఇది మీ వ్యవస్థాకి డిఫాల్ట్ మోడ్ ఉపయోగించేది",
    "DOCUMENTATION": "డాక్యుమెంటేషన్",
    "DOC_DESC": "మా వివరమైన డాక్యుమెంటేషన్ వ్యాసాలను తనిఖీ చేయండి.",
    "FAQ_U": "ప్రతిష్టాతా ప్రశ్నలు",
    "FAQ_DESC": "Agent AI గురించి అక్కడ అక్కడ కోరికలు అంచనా చేయండి.",
    "KORE_ACADEMY": "కోర్ అకాడమి",
    "KORE_ACA_DESC": "అకాడమీ కోర్సులను విస్తరించి Agent AI గురించి మరిన్ని నేర్చుకోండి.",
    "SEARCH": "శోధన",
    "MY_BOT": "నా బాట్",
    "ASSIST": "సహాయం చేయండి",
    "TRANSCRIPT": "రికార్డు",
    "HISTORY": "చరిత్ర",
    "STARTOVER": "మళ్ళీ ప్రారంభించండి",
    "RESTART_INPUTS": "తెలియజేస్తున్న ఇన్పుట్లతో మళ్ళీ ప్రారంభించండి",
    "ASKCUSTOMER": "గ్రాహకుని కోరండి",
    "TELLCUSTOMER": "గ్రాహకుని చెప్పండి",
    "WELCOME_MSG": "స్వాగత సందేశం",
    "SEND": "పంపండి",
    "SENT": "పంపబడింది",
    "FILE_NAME":"ఫైల్ పేరు",
    "AUTO_SCROLL_TOOLTIP":"అసిస్ట్ ట్యాబ్, నా బాట్ & ట్రాన్స్క్రిప్ట్ ట్యాబ్ కంటెంట్ యొక్క ఆటో-స్క్రోలింగ్‌ను నియంత్రిస్తుంది",
    "AWAITING": "స్పందించడం కోసం కేవలం టైప్ చేయండి | కొన్ని సరియైనవి",
    "OVERRIDE": "కొన్ని సరియైనవి కోసం టైప్ చేయండి",
    "OVERRIDE_FILE": "కొన్ని సరియైనవి కోసం ఫైల్ సంయుక్తం చేయండి",
    "ACCEPT_RESPONSE": "స్పందించిన స్పందనాన్ని అంగీకరించబడింది",
    "AGENT_ENTERED": "ఏజెంట్ ప్రవేశించాడు",
    "EXPECTED_FORMAT": "ఎక్కువ లెక్కింపు",
    "INPUT_VALUES": "ఇన్పుట్ విలువలు",
    "RESTART": "మళ్ళీ ప్ రారంభించు",
    "START_OVER": "మళ్ళీ ప్రారంభించు",
    "RESTART_CAPTURE": "తెలియజేస్తున్న ఇన్పుట్లతో మళ్ళీ ప్రారంభించు",
    "CANCEL": "రద్దు చేయండి",
    "TAB_TEXT":"ట్యాబ్‌లు ప్రారంభించబడలేదు! దయచేసి కనీసం ఒక ట్యాబ్ ప్రారంభించండి",
    "INTERRUPT_DIALOG": "మధ్యాహ్న సంవాద పని",
    "RUN": "రన్",
    "RUN_AGENT": "ఏజెంట్ ఇన్పుట్లతో రన్",
    "STEP": "అడుగున మార్గం",
    "DIALOG_TASK": "సంవాద పని",
    "FAQ": "సాధారణ ప్రశ్నలు",
    "SNIPPET": "సమాధానాలు",
    "ARTICLE": "వెబ్ పేజీలు",
    "TAP_SEARCH":"శోధించడానికి తక్కువ",
    "FILE": "ఫైళ్ళు",
    "SUGGESTED": "సూచించబడింది",
    "ALL_DIALOG": "అన్ని సంవాద పనులు",
    "DIALOG_TEXT": "సంవాదం",
    "INTENT_IDENTIFIED": "గ్రాహక అవాక్యం",
    "NOT_WHAT_LOOKING": "తప్పు సలహా?",
    "BOT": "బాట్",
    "CUSTOMER": "గ్రాహకుడు",
    "YOU": "మీరు",
    "TERMINATE_CONV": "సంవాద పని ముగిసివేయండి",
    "TERMINATE_CONV_DESC": "మీరు ఖచ్చితంగా సంవాద పనిని ముగిసివేయాలా? ఏజెంట్ AI సలహాలు ఇవ్వడం ద్వారా ఎక్కడా లేదు.",
    "YES_TERMINATE": "అవును ముగిసేయండి",
    "NO_CANCEL": "కాదు, రద్దు చేయండి",
    "OVERRIDE_CONTINUE": "ఓవర్రైడ్ మోడ్తో కొనసాగండి",
    "SUMMARY_TEXT": "సంక్షిప్తం",
    "SUBMIT": "సమర్పించండి",
    "INTERRUPT_OCCURED": "విధ్వంసం జరిగింది",
    "IDENTIFIED_INTENT": "గుర్తించబడింది ఉద్దేశం",
    "INTERRUPT_DESC": "ఇది ప్రస్తుత మీ ప్రారంభించిన సంవాద పనిని ముగిసేయండి.",
    "ACCEPT_RUN": "అంగీకరించండి మరియు రన్ చేయండి",
    "RUN_LATER": "తరువాత రన్ చేయండి",
    "KNOW_MORE": "మరిన్ని తెలుసుకోండి",
    "MORE_TEXT": "మరింత",
    "LESS_TEXT": "తక్కువ",
    "VIEW_MORE": "మరిన్ని వీక్షించండి",
    "VIEW_LESS": "తక్కువ వీక్షించండి",
    "SHOW_MORE_FAQ": "మరిన్ని సాధారణ ప్రశ్నలు చూపించు",
    "SHOW_LESS_FAQ": "తక్కువ సాధారణ ప్రశ్నలు చూపించు",
    "SHOW_MORE_ARTICLE": "మరిన్ని వెబ్ పేజీలు చూపించు",
    "SHOW_LESS_ARTICLE": "తక్కువ వెబ్ పేజీలు చూపించు",
    "SHOW_MORE_SNIPPET": "మరిన్ని సమాధానాలు చూపించు",
    "SHOW_LESS_SNIPPET": "తక్కువ సమాధానాలు చూపించు",
    "SHOW_MORE_FILES": "మరిన్ని ఫైళ్ళు చూపించు",
    "SHOW_LESS_FILES": "తక్కువ ఫైళ్ళు చూపించు",
    "VIEW_ALL_DIALOG": "అన్ని సంవాదాలను చూపించు",
    "VIEW_FEW_DIALOG": "కొన్ని సంవాదాలను చూపించు",
    "HELP_FULL": "ఉపయోగకరంగా?",
    "THANKYOU": "ధన్యవాదాలు!",
    "EXPAND_MORE": "విస్తరించండి / మరింత",
    "CLOSE_TEXT": "మూసుకోండి",
    "STARTED": "ప్రారంభించారు",
    "ENDED": "ముగించింది",
    "VIEW_FULL_ARTICLE": "వెబ్ పేజీ చూపించు",
    "VIEW_FULL_FILE": "ఫైల్ చూపించు",
    "COPIED": "ప్రత్యక్షించబడింది",
    "SENTI_ANALY": "భావనా విశ్లేషణ",
    "WRONG_SUGGESTION": "తప్పు సలహాలు",
    "INCORRECT_INTENT": "తప్పు ఉద్దేశం",
    "ACCIDENTAL_CLICK": "దురదృష్టములో నొక్కిన",
    "TIME_TAKING": "సమయం తీసుకోవడం",
    "OTHER": "ఇతర",
    "PLAYBOOK_EMPTY_MSG": "ప్లేబుక్ను ఎంచుకోండి",
    "PLAYBOOK_EMPTY_DESC": "అన్ని అంతిమ ప్లేబుక్లు డైనమిక్ ఉంటే, ఏజెంట్ AI ప్లేబుక్ను లోడ్ చేయలేకపోతుంది. ప్లేబుక్ను ప్రవేశించడానికి 'ప్లేబుక్ ఎంచుకోండి' నొక్కండి.",
    "STAGE": "స్థాయి",
    "PROCEED_TO_CLOSE": "మూసివేయడానికి క్రింది నొక్కండి",
    "RECOMENDED_PLAYBOOK": "సిఫార్చు చేసిన ప్లేబుక్",
    "PRIMARY_SCRIPTS": "ప్రధాన స్క్రిప్ట్లు",
    "DYNAMIC_SCRIPTS": "డైనమిక్ స్క్రిప్ట్లు",
    "RESUME": "ముందుకు పోవండి",
    "ENABLE_CLOSE": "మూసివేయడానికి క్రింది బటన్ నొక్కండి",
    "LIST_VIEW": "జాబితా వీక్షణ",
    "TERMINATE": "ముగింపు",
    "MINIMIZE": "తక్కువ చేసుకోండి",
    "MAXIMIZE": "పెద్ద చేయండి",
    "NO_SEARCH_RESULT": "యొక్క సోదరణ ఫలితం కనపడలేదు",
    "SENTIMENT_AWAITING": "భావనా కోసం కాదు",
    "POSITIVE": "పాజిటివ్",
    "NEGATIVE": "నెగెటివ్",
    "ASSOCIATED_WORK_NOTES": "గత పరిష్కరణ గమనాలు",
    "AGENT_JOINED_CONV": "ఏజెంట్ సంవాదంలో చేరాడు",
    "AUTOSCROLL_ASSIST": "ఆటో-స్క్రోల్ సహాయం ట్యాబ్ విషయం",
    "FILE_SIZE_MSG": "ఫైల్ పరిమాణం 25MB పైకి ఉండాలి. దయచేసి మళ్ళీ ప్రయత్నించండి.",
    "OVERRIDE_BTN": "ఓవర్రైడ్",
    "CHOOSE_FILE": "ఫైల్ ఎంచుకోండి",
    "SUMMARY_ERROR_TEXT": "క్షమించండి, కానీ ఈ సంవాదం కోసం సంగ్రహం నిర్మించడంలో సమస్య ఉంది. దయచేసి మీ స్వంత సారాంశం సృష్టించండి",
    "ASK_A_QUESTION": "ప్రశ్న అడగండి.",
    "COPY" : "కాపీ",
    "PLAYBOOK": "ప్లేబుక్",
    "TELL_US_MORE": "మాకు మరింత తెలియజేయండి",
    "THANKS_FEEDBACK": "మీ ఫీడ్‌బ్యాక్‌కి ధన్యవాదాలు",
    "SOMETHING_WRONG": "ఏదో తప్పైంది",
    "CLICK_ERROR_DETAILS": "తప్పు వివరాలు చూడడానికి క్లిక్ చేయండి",
    "NO_ACTIVE_PLAYBOOK": "సక్రియమైన ప్లేబుక్ లేదు",
    "REPHRASE_QUESTION": "మీ ప్రశ్నను పునరుద్ఘాటించగలారా లేదా ఇంకో విషయం అడగగలారా?",
    "VIEW_FULL_ARTICLE_2": "మొత్తం ఆర్టికల్ చూడండి",
    "VIEW_FULL_FILE_2": "మొత్తం ఫైల్ చూడండి",
    "INTERNAL_INFO": "అంతర్గత సమాచారం",
    "SOURCES": "మూలాలు",
    "CONVERSATION_SUMMARY": "సమావేశం సారాంశం",
    "WAITING": "అంచనా వేస్తున్నాను",
    "WIDGET_DISABLED": "విడ్జెట్ నిర్బంధించబడింది",
    "AI_SETTINGS_DISABLED": "AI సెట్టింగ్‌లు నిర్బంధించబడ్డాయి! AI నిర్వాహకునితో సంప్రదించండి",
    "SERVER_CONNECTION_ERROR": "సర్వర్‌కి కనెక్ట్ అవుతున్నప్పుడు పొరపాటు",
    "VIEW": "చూడండి",
    "ATTACHMENT_INPUT": "ఊపిక ఇన్పుట్",
    "TYPE_SUMMARY": "సారాంశం టైప్ చేయండి",
    "BY":"చే",
    GENERATE_SUMMARY: "సారాంశాన్ని రూపొందించండి",
    PREV_SUMMARIES: "మునుపటి రూపొందించిన సారాంశాలు",
    DIALOG_WORKFLOWS: "డైలాగ్ వర్క్‌ఫ్లోలు",
    SHOW_ALL_DIALOG: "అన్ని డైలాగ్ టాస్క్‌లను చూపించు",
    SHOW_ALL_DIALOGS: "అన్ని డైలాగ్‌లను చూపించు",
    CUSTOM_TAB: "కస్టమ్ ట్యాబ్",
    AGENT_INPUT: "ఏజెంట్ ఇన్పుట్",
    CUSTOM_EMPTY_MSG: "సక్రియమైన వర్క్‌ఫ్లోలు ఇప్పుడు లేవు",
    CUSTOM_TAB_DESC: "ఒక వర్క్‌ఫ్లోను ప్రారంభించడానికి, తలపైన పట్టికలో ఒకటిని ఇయక్తం చేయండి.",
    SUBMIT_OVERALL_FEEDBACK: "మొత్తం ఫీడ్బ్యాక్ సమర్పించండి",
    FEEDBACK_POPUP_SUBTITLE: "విడ్జెట్ మర్మంత సాధారణ ప్రశ్నలు చూపించు",
    FEEDBACK_SATISFIED: "సంతుష్టం",
    FEEDBACK_UNSATISFIED: "సంతుష్టం కాదు",
    FEEDBACK_PROVIDE_REASONS: "మరింత సమాచారం ఇవ్వండి",
    FEEDBACK_TITLE: "ఫీడ్బ్యాక్",
    "AGENTIC_THINKING" : "ఆలోచిస్తోంది",
    "AGENTIC_AGENT_TITLE" : "ఏజెంట్",
    "AGENTIC_COPILOT_MODE_TITLE" : "ఏజెంటిక్ కోపిలాట్ మోడ్",
    "AGENTIC_SENDING_MESSAGE" : "పంపుతోంది...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot మీ సంభాషణను చురుకుగా వింటోంది మరియు స్వయంచాలకంగా సహాయం చేయడానికి సిద్ధంగా ఉంది",
    "AGENTIC_SEARCH_RESULTS" : "ఏజెంట్ ఫలితాలు",
    "PAUSE_AUTO_SEND" : "స్వయంచాలక పంపడాన్ని విరామం చేయి",
    "PAUSE_AGENTIC" : "ఏజెంట్‌ను విరామం చేయి",
    "RESUME_AGENTIC" : "ఏజెంట్‌ను మళ్లీ ప్రారంభించు",
    "RESUME_AUTO_SEND" : "స్వయంచాలక పంపడాన్ని మళ్లీ ప్రారంభించు"
}